export { default } from './Holiday';
